<template>
  <div class="side-bar-summary-desktop">
    <side-bar-promo
      v-if="!isDeletedAll"
      class="side-bar-summary-desktop__promo"
      :class="{ '_show-mnogo-ru': showMnogoRuCard }"
      @changePromoCode="handlerChangedPromoCode"
      @showMnogoRuCard="handlerShowMnogoRuCard"
    />
    <basket-summary
      class="side-bar-summary-desktop__summary"
      :amount="amount"
      :discount-amount="discountAmount"
      :quantity="quantity"
      :weight="weight"
      :cashback="cashback"
      :max-pay-bonuses="maxPayBonusesAsNumber"
      :is-deleted-all="isDeletedAll"
    />
    <side-bar-cheapest-deliveries
      v-if="cheapestDeliveries.length && !isDeletedAll"
      :cheapest-deliveries="cheapestDeliveries"
      class="side-bar-summary-desktop__cheapest-deliveries side-bar-summary-desktop__row"
    />
    <div v-if="shipmentDate && !isDeletedAll" class="side-bar-summary-desktop__shipment-date side-bar-summary-desktop__row">
      <span>Передадим в службу доставки</span>
      <span class="nobr">{{ shipmentDate }}</span>
    </div>
    <div class="side-bar-summary-desktop__main-link side-bar-summary-desktop__row">
      <button-control
        size="large"
        is-block
        :disabled="isDisabledOrderButton"
        :is-added-disabled-class-name="isDisabledOrderButton"
        @click="handlerClickButtonGoCheckout"
      >
        Перейти к оформлению
      </button-control>
    </div>
    <side-bar-payments-list class="side-bar-summary-desktop__payments side-bar-summary-desktop__row" />
    <loader-block v-if="isLoading" text="" class="side-bar-summary-desktop__loader" />
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { LoaderBlock, ButtonControl } from '@book24/ui-components';

import { AMOUNT_DEFAULT_VALUE, DISCOUNT_AMOUNT_DEFAULT_VALUE } from '@/compositions/basket/basketStorage';

import useBasketSummary from '@/compositions/useBasketSummary';

import BasketSummary from '@/components/BasketSummary/index.vue';
import SideBarPromo from '@/components/SideBarPromo/index.vue';
import SideBarPaymentsList from '@/components/_desktop/SideBarPaymentsList/index.vue';
import SideBarCheapestDeliveries from '@/components/_desktop/SideBarCheapestDeliveries/index.vue';

export default defineComponent({
  name: 'SideBarSummary',
  components: {
    LoaderBlock,
    ButtonControl,
    BasketSummary,
    SideBarPromo,
    SideBarPaymentsList,
    SideBarCheapestDeliveries,
  },
  props: {
    cashback: { type: Number, default: 0 },
    quantity: { type: Number, default: 0 },
    weight: { type: Number, default: 0 },
    maxPayBonuses: { type: [Number, String], default: 0 },
    amount: { type: Object, default: () => ({ ...AMOUNT_DEFAULT_VALUE }) },
    discountAmount: { type: Object, default: () => ({ ...DISCOUNT_AMOUNT_DEFAULT_VALUE }) },
    isLoading: { type: Boolean, default: false },
    cheapestDeliveries: { type: Array, default: () => ([]) },
    shipmentDate: { type: String, default: null },
    isDeletedAll: { type: Boolean, default: false },
    unavailableItemsLength: { type: Number, default: 0 },
  },
  setup(props) {
    const basketSummary = useBasketSummary(props);
    return { ...basketSummary };
  },
});
</script>

<style lang="less">
.side-bar-summary-desktop {
  border: 1px solid @gray-super-light;
  box-sizing: border-box;
  border-radius: @size-x2;
  padding-top: @size-x6;
  padding-bottom: @size-x6;
  position: relative;
  overflow: hidden;

  &__summary {
    .basket-summary__item {
      padding: 0 @size-x6;

      &._total {
        margin-top: @size-x4;
        padding-top: @size-x5;
      }
    }

    .basket-summary__desc {
      .small();

      font-weight: normal;
    }

    .basket-summary__val,
    .basket-summary__item._total .basket-summary__desc,
    .basket-summary__item._total .basket-summary__val {
      .h4-desktop();
    }
  }

  &__promo {
    padding: 0 @size-x6 @size-x2;
    border-bottom: 1px solid @gray-super-light;
    margin-bottom: @size-x4;

    &._show-mnogo-ru {
      padding-bottom: 0;
    }
  }

  &__row {
    padding: 0 @size-x6;
  }

  &__main-link {
    margin-top: @size-x4;
  }

  &__payments {
    .small();

    margin-top: @size-x6;
  }

  &__cheapest-deliveries {
    .small();

    margin-top: @size-x2;
  }

  &__shipment-date {
    .small();

    display: flex;
    justify-content: space-between;
    margin-top: @size-x2;
  }

  &__loader {
    z-index: 2;
  }
}
</style>
